import type { MainPanelConfig, TabOption } from "@/panels/modules/panels/store/panels.store.types";

/**
 * Default config for one main panel. Shared by reference across all four main
 * panels in `defaultMainState`, and only *shallowly* frozen (the nested `a`/`b`
 * tab objects are not frozen).
 *
 * This is safe today because every store setter copies-on-write (spreads a new
 * object) and never mutates a slice in place. If the store is migrated to Immer,
 * this becomes a freeze/aliasing hazard: Immer's auto-freeze reaches through the
 * shared reference and deep-freezes this module constant, after which any in-place
 * write throws. On that migration, give each panel its own deeply frozen copy
 * (e.g. `freeze(structuredClone(defaultMainPanelConfig), true)`), never one shared
 * ref. The "Immer-migration guardrails" tests in `panels.store.test.ts` fail if
 * this invariant regresses.
 */
export const defaultMainPanelConfig: MainPanelConfig = Object.freeze({
    selectedTab: "a",
    a: {
        headerTitle: "Tab A",
        tabTitle: "Tab A",
        isMinimized: false,
        isClosed: true,
        showHeader: true,
    },
    b: {
        headerTitle: "Tab B",
        tabTitle: "Tab B",
        isMinimized: false,
        isClosed: true,
        showHeader: true,
    },
});

export function isTabOption(value: string | null): value is TabOption {
    return value === "a" || value === "b";
}

export const getOtherTab = (tab: TabOption): TabOption => {
    return tab === "a" ? "b" : "a";
};
